import PropTypes from 'prop-types';
import IconButton from '../../atom/IconButton';
import useComponentVisible from '../../../../../utilities/hooks/useComponentVisible';
import dots from '../../../../../assets/icons/ic_three_dots.svg';
import {ReactComponent as EditIcon} from '../../../../../assets/icons/ic_pencil.svg';
import {ReactComponent as TrashIcon} from '../../../../../assets/icons/ic_trash.svg';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import {DateFormatHelper} from "../../../../../utilities/helpers/DateFormatHelper";
import {URI_GOOGLE_MAPS_PLACE_ID} from "../../../../../config";

const PointOfInterestItem = ({ item,onEditClicked,onPoiClicked }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const dictionary = useDictionary();
    const onContextClicked = () => {
		setIsComponentVisible(!isComponentVisible);
	};
    
	return (
		<tr style={{ cursor: 'pointer' }} className='provider-review-row pois-row' onClick={() => onPoiClicked(item)}>
			<td>
				<div className="provider-customers-duration">{item.input}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.search_input}</div>
			</td>
			<td>
				<div className='provider-customers-duration'>
					<a target="_blank" href={URI_GOOGLE_MAPS_PLACE_ID + item.place_id}>{item.place_id}</a>
				</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.name}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.poi_booking_module_eligibility}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.operator_booking_module_eligibility	}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.location_type ?? 'Unmatched'}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.matched}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.status}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.iteration ? DateFormatHelper.dayMonthTimeFormat(item.iteration) : '-'}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.parsed_at ? DateFormatHelper.dayMonthTimeFormat(item.parsed_at) : '-'}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.force_update}</div>
			</td>
			<td>
				<div className="provider-customers-duration">{item.closed}</div>
			</td>
            <td>
				<div className="provider-customers-actions-wrapper d-flex-center">
					<IconButton onClickIcon={onContextClicked} activeState={isComponentVisible} styleObject={{width: '32px',height: '32px',borderRadius: '6px'}}>
						<img src={dots} />
					</IconButton>

					<div ref={ref} className="provider-customers-action-menus-container">
						{isComponentVisible ? (
							<>
								<div className="provider-customers-actions-container">
                                    <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onEditClicked(item.id)}}>
										<EditIcon />
                                        <div>{dictionary.edit}</div>
                                    </div>
									{/* <div className="provider-customers-action-container" onClick={(e) => {e.stopPropagation();onDeleteClicked(item)}}>
										<TrashIcon />
										<div>{dictionary.delete}</div>
									</div> */}
                                </div>
							</>
						) : null}
					</div>
				</div>
			</td>
		</tr>
	);
};

PointOfInterestItem.propTypes = {
	item: PropTypes.object,
	onPoiClicked: PropTypes.func,
    columns: PropTypes.object
};

export default PointOfInterestItem;